import { tsValidateString, tsValidateValue } from '@nu-art/ts-common';
import { smartDocStaticParamType_Factor } from './types.js';
import { Validator_SmartDocStaticParamType } from '../_base/index.js';
import { Validator_SmartDocParmaResolver_VariableResolver } from '../../../smart-doc-param-resolver/index.js';
import { variableType_PrecipitatingFactor, variableType_RelievingFactor } from '@app/hcs-shared';
export const Validator_SmartDocStaticParam_Factor = {
    key: tsValidateString(),
    type: Validator_SmartDocStaticParamType,
    subType: tsValidateValue([smartDocStaticParamType_Factor]),
    resolver: Validator_SmartDocParmaResolver_VariableResolver,
    parentKey: tsValidateString(),
    factorType: tsValidateValue([variableType_RelievingFactor, variableType_PrecipitatingFactor]),
};
//# sourceMappingURL=validator.js.map